import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TrackParcelService } from 'src/app/services/track-parcel.service';
import { User } from '../../models/user';
import { ErrorService } from '../../services/error.service';
import { SnackbarService } from '../../services/snackbar.service';
import { SpinnerService } from '../../services/spinner.service';
import { SubscriptionService } from '../../services/subscription.service';
import { ValidatorService } from '../../services/validator.service';
import { ParcelService } from '../../services/parcel.service';

enum ParcelAttachmentType {
	PDF = 'PDF',
	CSV = 'CSV'
}

@Component({
	selector: 'app-email-parcel-details-modal',
	templateUrl: './email-parcel-details-modal.html',
	styleUrls: ['./email-parcel-details-modal.component.scss']
})
export class EmailParcelDetailsModalComponent implements OnInit, OnDestroy {
	public form: UntypedFormGroup;
	public selectedLabelIsDefault: boolean;
	public shippingLabels: any[];
	public subscriptions: any[] = [];
	public user: User = new User();
	public customer = JSON.parse(localStorage.getItem('Rapidship:customer'))
	parcelAttachmentType = ParcelAttachmentType 

	constructor(private _trackParcelService: TrackParcelService,
				private _errorService: ErrorService,
				public dialogRef: MatDialogRef<EmailParcelDetailsModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
				private _formBuilder: UntypedFormBuilder,
				private _validatorService: ValidatorService,
				private _spinnerService: SpinnerService,
				private _snackbarService: SnackbarService,
				private _subscriptionService: SubscriptionService,
				private _parcelService: ParcelService) {
	}

	close(response?) {
		this.dialogRef.close(response);
	}

	ngOnDestroy() {
		this._subscriptionService.unSubscribe(this.subscriptions);
	}

	ngOnInit() {
		this.form = this._formBuilder.group({
			email: ['', [Validators.email]],
			emails: [[], [this._validatorService.minArrayLength(1)]],
			subject: [null, [Validators.required]],
			message: [null, [Validators.required]],
			fileFormat: ['PDF']
		});
		this.subscriptions.push(this.form.get('emails').valueChanges.subscribe((value) => {
			if (value?.length === 10) {
				this.form.get('email').disable();
			} else if (this.form.get('email').disabled && value?.length < 10) {
				this.form.get('email').enable();
			}
		}));
	}

	submit(form) {
		if (form.valid) {
			this._spinnerService.startSpinner();

			if (this.data.viewType == 'TABLE') {
				this.emailParcelRecords(form)
			}
			else if (this.data.viewType == 'DETAILED') {
				this.emailParcelDetails(form)
			}
			else if (this.data.viewType == 'EMAIL_PARCELS_FOR_ORDER') {
				this.emailAllParcelsForOrder(form)
			}
			else if (this.data.viewType == 'EMAIL_PARCELS_FOR_ROUTE_STOP') {
				this.emailParcelsForRouteStop(form)
			}
			
		} else {
			if (this.form.get('emails').errors) {
				this.form.get('email').setErrors({minLength: true});
				this.form.get('email').markAsTouched();
			}
			this._snackbarService.openSnackBar('Please fill out all required fields.', 'Close', 3000);
		}
	}

	emailParcelRecords(form) {
		this.data.searchRequestEmail.email = {
			subject: form.value.subject,
			body: form.value.message,
			emails: form.value.emails
		}

		this.data.searchRequestEmail.attachmentType = form.value.fileFormat

		this._trackParcelService.emailParcels(
			this.data.searchRequestEmail,
			this.data.others.includePartialMatches,
			this.data.others.beginDate,
			this.data.others.endDate,
			this.data.others.numRecentParcels,
			this.data.others.sortColumn,
			this.data.others.sortDirection,
			this.customer.customerName		
		).subscribe(() => {
			this._spinnerService.stopSpinner();
			this.close(true);
		}, error => {
			this._spinnerService.stopSpinner();
			this._errorService.error(error, 'emailParcelRecords Failed', 'modal');
		});
	}

	emailParcelDetails(form) {
		var email = {
			subject: form.value.subject,
			body: form.value.message,
			emails: form.value.emails
		}
		this._trackParcelService.emailParcelDetails(
			this.data.id,
			email
		).subscribe(() => {
			this._spinnerService.stopSpinner();
			this.close(true);
		}, error => {
			this._spinnerService.stopSpinner();
			this._errorService.error(error, 'emailParcelDetails Failed', 'modal');
		});
	}

	emailAllParcelsForOrder(form) {
		var email = {
			subject: form.value.subject,
			body: form.value.message,
			emails: form.value.emails
		}
		this._parcelService.emailParcelForOrderOrRoute(
			this.data.id,
			email,
			this.data.others.isOrderOnDemand,
			this.data.others.postDate
		).subscribe(() => {
			this._spinnerService.stopSpinner();
			this.close(true);
		}, error => {
			this._spinnerService.stopSpinner();
			this._errorService.error(error, 'emailParcelForOrder Failed', 'modal');
		});
	}

	emailParcelsForRouteStop(form) {
		var email = {
			subject: form.value.subject,
			body: form.value.message,
			emails: form.value.emails
		}
		this._trackParcelService.emailParcelsForRouteStop(
			this.data.id,
			email
		).subscribe(() => {
			this._spinnerService.stopSpinner();
			this.close(true);
		}, error => {
			this._spinnerService.stopSpinner();
			this._errorService.error(error, 'emailParcelForOrder Failed', 'modal');
		});
	}
}
